var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ai"},[_c('div',{staticClass:"ai-2"}),_c('div',{staticClass:"ai-3"}),_c('div',{staticClass:"ai-4"})])}]

export { render, staticRenderFns }